import * as React from 'react';

interface ISubBenefit {
  name: string;
  text: string;
  subkeyOf: string;
}

interface IBenefit {
  title: string;
  coverLevel?: string;
  description: any;
  value: any;
  hasSubBenefits?: boolean;
  subBenefits?: ISubBenefit[];
}

class Benefit extends React.Component<IBenefit> {
  public render() {
    const { hasSubBenefits, subBenefits } = this.props;
    const benefitValue = (isSubBenefit = false) => {
      const { title, value, coverLevel } = this.props;

      if (title === 'Winter sports') {
        return 'Optional';
      }

      if (title === 'Cruise cover' && coverLevel === 'platinum') {
        return 'Included as standard';
      }

      if (title === 'Cruise cover' && coverLevel !== 'platinum') {
        return 'Optional';
      }

      if ((title === 'Gadget cover' || title === 'Golf cover') && coverLevel !== 'admiral') {
        return 'Optional';
      }

      if (value === '') {
        return ' - ';
      }

      return value === 'n/a' ? 'x' : value;
    };

    return (
          <div className="quote-section"
               style={{
                 display: 'flex',
                 flexDirection: 'column',
                 alignItems: 'center',
                 paddingTop: '20px',
                 paddingBottom: '20px',
                 marginBottom: '10px',
               }}
          >
            <div
                style={{
                    display: 'flex',
                    height: '40px',
                    alignItems: 'center',
                    fontSize: '14px',
                    marginBottom: '10px',
                }}>
                {benefitValue()}
            </div>
            {hasSubBenefits && (
              <div>
                {subBenefits.map((subBenefit, index) => (
                    <div key={index}
                         style={{
                             height: '25px',
                             alignItems: 'center',
                             marginLeft: '1px',
                             fontSize: '13px',
                             marginBottom: subBenefit.name.length > 41 ? '4px' : '3px',
                         }}
                    >
                      {subBenefit.text}
                    </div>
                ))}
              </div>
            )}
          </div>
    );
  }
}

export default Benefit;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/SchemeChoiceB/components/Benefit/index.tsx